module.exports = __webpack_public_path__ + "img/bnk.d9785c50.png";